export default "__VITE_ASSET__6b859268__"